import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../styles/fonts/SohneMono-Buch.woff2%22,%22weight%22:%22400%22,%22display%22:%22swap%22}],%22variableName%22:%22sohneMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'sohneMono', 'sohneMono Fallback'",
        fontWeight: 400,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
